import { combineReducers  } from 'redux';
import { orderRequest } from './orderReducer';
import { geotargetRequest } from './geotargetsReducer';
import { geogroupsRequest } from './geogroupsReducer';

import { selectedPlacements, placementRequest } from './placementReducer';
import { strategyRequest, salesProductsRequest } from './strategyReducer';
import { mainSearchRequest } from './mainSearchReducer';
import { preferencesRequest } from './preferencesReducer';
import { buyersSearchRequest } from './buyersSearchReducer';
import { creativeProductsRequest, creativeProductsLookup } from './creativeProductsReducer';
import user from './userReducer';
import advertiserRequest from './advertiserReducer';
import advertisersRequest from './advertisersReducer';
import buyersRequest from './buyersReducer';
import deviceTypesRequest from './deviceTypesReducer';
import acceptRequest from './acceptReducer';
import newbuyerRequest from './newbuyerReducer';
import constantRequest from './constantReducer';
import ccpRequest from './customCriteriaPresetReducer';
import tptRequest from './thirdPartyTargetingReducer';
import geoRequest from './geotargetsReducer';
import { packageRequest } from './packageReducer';

const rootReducer = combineReducers({
  user,
  constantRequest,
  ccpRequest,
  orderRequest,
  mainSearchbar: mainSearchRequest,
  strategyRequest,
  geotargetRequest,
  placementRequest,
  advertiserRequest,
  deviceTypesRequest,
  advertisersRequest,
  buyersRequest,
  buyersSearchRequest,
  selectedPlacements,
  salesProductsRequest,
  creativeProductsLookup,
  creativeProductsRequest,
  geogroupsRequest,
  tptRequest,
  acceptRequest,
  newbuyerRequest,
  preferencesRequest,
  geoRequest,
  packageRequest,
});

export default rootReducer;
